module.exports = __webpack_public_path__ + "static/media/lax.307ff29a.png";